var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJewelry = function SvgJewelry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#jewelry_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#970CEB",
    d: "M4.5 0a.75.75 0 0 0-.625.334l-1 1.5a.75.75 0 0 0-.031.782l.994 1.787A6.001 6.001 0 0 0 6 16 6.002 6.002 0 0 0 8.162 4.403l.994-1.787a.75.75 0 0 0-.031-.782l-1-1.5A.75.75 0 0 0 7.5 0zm2.15 4.034a6.4 6.4 0 0 0-1.3 0l-.972-1.75L4.9 1.5h2.197l.525.784zM1.5 10a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "jewelry_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v16H0z"
  })))));
};
export default SvgJewelry;